import { defineMessages } from 'react-intl';

import generalMessages from 'src/messages';

const messages = defineMessages({
  uploadPlateTemplate: {
    id: 'uploadPlateTemplate',
    defaultMessage: 'Upload plate template'
  },
  plateSizeDetails: {
    id: 'plateSizeDetails',
    defaultMessage: 'Plate size and details'
  },
  normalizationAndAliquots: {
    id: 'normalizationAndAliquots',
    defaultMessage: 'Normalization and aliquots'
  },
  reviewAndAddToCart: {
    id: 'reviewAndAddToCart',
    defaultMessage: 'Review and add to cart'
  },
  tooltipUploadPlateTemplate: {
    id: 'tooltipUploadPlateTemplate',
    defaultMessage: 'Please upload a valid file before moving to the next step.'
  },
  tooltipPlateError: {
    id: 'tooltipPlateError',
    defaultMessage: 'All plate errors must be resolved before moving to the next step.'
  },
  tooltipRestSteps: {
    id: 'tooltipRestSteps',
    defaultMessage: 'All fields must be completed or selected before moving to the next step.'
  }
});

export default { ...generalMessages, ...messages };
